
import Vue from "vue";
import Component from "vue-class-component";
import HeaderRegister from "@/components/register/HeaderRegister.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import BodyRegister from "@/components/register/BodyRegister.vue";
import { Action, State } from "vuex-class";
import { ActionCallback } from "@/store/types";
import { Watch } from "vue-property-decorator";

@Component({
  components: {
    BodyRegister,
    AppNavbarSecondary,
    HeaderRegister,
    AppFooter,
  },
})
export default class Register extends Vue {
  items = [
    {
      image: "career",
      text: "Portal Karir",
    },
    {
      image: "information",
      text: "Info & berita",
    },
    {
      image: "academic",
      text: "Akademik",
    },
    {
      image: "learning",
      text: "Belajar",
    },
    {
      image: "cv",
      text: "Buat CV",
    },
  ];
  tokenValid: boolean | null = null;
  eventActive: boolean | null = null;
  eventEndDate: string | null = null;
  loading: boolean = true;
  useApi: boolean = true;

  @Action("validateCandidateCode", { namespace: "school" })
  validateCandidateCode!: (
    callback: ActionCallback<
      ServerResponse<CandidateCode & { school: School }>,
      { code: string }
    >
  ) => Promise<void>;

  @State("school", { namespace: "school" }) school!: School;
  @Watch("$store.state.school.school", { immediate: true })
  async validateToken() {
    const code = this.$route.query.code as string;
    // console.log("Route query params:", this.$route.query);
    // console.log("Token code from URL:", code);

    // If no code present, set invalid state
    if (!code) {
      console.log("No code found in URL - allow acess to register");
      this.tokenValid = false;
      this.eventActive = false;
      this.loading = false;
      return;
    }

    if (this.useApi) {
      try {
        this.loading = true;
        await this.validateCandidateCode({
          params: { code },
          success: ({ data: { data } }) => {
            this.tokenValid = this.school.id == data.school_id;
            // Check if event is still active
            const today = new Date();
            const endDate = new Date(data.expired_date);
            this.eventActive = this.tokenValid && today <= endDate;
            this.eventEndDate = data.expired_date;
          },
          fail: (response) => {
            this.tokenValid = false;
            this.eventActive = false;
          },
        });
      } catch (error) {
        console.error("Error validating token:", error);
        this.tokenValid = false;
        this.eventActive = false;
      } finally {
        this.loading = false;
      }
    } else {
      // Testing with dummy data
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Dummy token list
      const validTokens = [
        {
          code: "VALID123",
          eventEndDate: "2025-12-31",
          isActive: true,
        },
        {
          code: "EXPIRED456",
          eventEndDate: "2023-01-01",
          isActive: false,
        },
      ];

      // Cari token yang cocok
      const matchedToken = validTokens.find((token) => token.code === code);

      if (matchedToken) {
        this.tokenValid = true;
        const today = new Date();
        const endDate = new Date(matchedToken.eventEndDate);
        this.eventActive = today <= endDate && matchedToken.isActive;
        this.eventEndDate = matchedToken.eventEndDate;
      } else {
        this.tokenValid = false;
        this.eventActive = false;
      }

      this.loading = false;
    }
  }

  get templateNumber() {
    return Number(this.$route.query?.template || 1);
  }
}
